<div class="card my-5">
    <div class="card-body">
      <form (ngSubmit)="onSubmit()" #commentForm="ngForm">
        <div class="form-group">
          <label for="name">Name</label>
          <input type="text" [(ngModel)]="rating.username" 
            class="form-control"
            id="name"
            name="name"
            placeholder="Enter your name"
            required #name="ngModel">
        </div>
        <div [hidden]="!name.pristine" class="alert alert-danger">Name is required</div>
        <div class="form-group">
          <label for="stars">Rating</label>
          <input type="number" [(ngModel)]="rating.stars" 
            class="form-control"
            id="stars"
            name="stars"
            placeholder="Enter your rating(0-5)"
            required #stars="ngModel">
          <div [hidden]="!stars.pristine" class="alert alert-danger">Rating is required</div>
        </div>
        <button type="submit" [disabled]="!commentForm.form.valid" 
          class="btn btn-info">Submit</button>
          <a routerLink="" class="btn btn-info">Back</a>
        </form>
    </div>
  </div>